import { toast } from "sonner";
import { useUndoConversionMutation } from "@/store/rest_api";
import { apiErrorMessage } from "@/util/apiError";

export function useConversionToast() {
  const [undoConversion] = useUndoConversionMutation();

  return (contactId: string | undefined, name?: string | null) => {
    if (!contactId) {
      return;
    }
    const person = name?.trim() || "This lead";
    toast(`${person} is now a contact`, {
      action: {
        label: "Undo",
        onClick: () => {
          undoConversion(contactId)
            .unwrap()
            .then(() => {
              toast.success(`${person} is a lead again`);
            })
            .catch((error: unknown) => {
              toast.error(apiErrorMessage(error, "Could not undo the conversion"));
            });
        },
      },
    });
  };
}
